import React from 'react';
import styled from 'styled-components';



const topHeader =  styled.div.attrs({
    className: 'page__top-header',
})`
  padding-top: 0.5rem;
  font-size: 2rem;
  color: ${ props => props.theme.colors.customFlatTextColor || (!props.invertedColors ? props.theme.colors.primaryText : props.theme.colors.primaryTextInverted) };
  font-weight: 300;

`;

export default topHeader;

